<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      :persistent='true'
      width="50%"
      height="100%"
      class="modalDialog"
      no-click-animation
    >
      <CardTitle title="配信実績詳細" />
      <v-card-actions class="cardWrap__scroll">
        <v-container>
          <v-form
            class="cardWrap__fromArea"
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-row justify="space-around" class="formHeight">
              <v-col cols="2">配信日</v-col>
              <v-col cols="10">
                <span style="padding-left: 10px;">{{ fromSetData.delivery_date }}</span>
              </v-col>
            </v-row>
            <v-row justify="space-around" class="formHeight">
              <v-col cols="2">対象</v-col>
              <v-col cols="10">
                <span style="padding-left: 10px;">{{ fromSetData.golf_name }}</span>
              </v-col>
            </v-row>
            <v-row justify="space-around" class="formHeight">
              <v-col cols="2">配信種別</v-col>
              <v-col cols="10">
                <span style="padding-left: 10px;">{{ fromSetData.delivery_name }}</span>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="desserts"
              hide-default-footer
              class="elevation-1"
              sort-by="memberNo">
              <template v-slot:top>
              </template>
            </v-data-table>
            <!--
            <v-row justify="space-around" class="formHeight my-3 px-3">
              <v-tabs
                background-color="white accent-4"
                color="black"
                v-model="deliveryType"
              >
                <v-tab
                  v-for="(val, index) in this.useTemplateList"
                  :key="index"
                  :value="val.delivery_type"
                  @click="ChangeTemplate(val)"
                  >{{ val.delivery_type_code_name }}本文
                </v-tab>
              </v-tabs>
            </v-row>
            <v-textarea
                v-model="template"
                readonly
                rows="5"
                outlined
                no-resize
                solo
            />
            -->
            <!-- <v-row justify="start">
              <div class="cardWrap__fromArea__title">有効フラグ</div>
                <v-checkbox v-model="fromSetData.valid_flag" class="mx-2" label="有効フラグ" />
            </v-row> -->
          </v-form>
        </v-container>
      </v-card-actions>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green darken-4" text @click="CloseModal">閉じる</v-btn>
        <!-- <v-btn color="green darken-4" text v-if="addModeStatus" @click="OnConfirmOverlay">登録</v-btn>
        <v-btn color="green darken-4" text v-if="changeModeStatus" @click="OnConfirmOverlay">変更</v-btn> -->
      </v-card-actions>
    </v-dialog>
  </v-row>
</template>

<script>
import CardTitle from '@/components/module/CardTitle';
import validater from '../../../lib/validater';
import { GET_DELIVERY_ACTUALS_DETAILS } from '@/constants/delivery_actuals';
// import { GET_TEMPLATE_LIST } from '@/constants/master';

export default {
    components: {
        CardTitle
    },
    data () {
        return {
            dialog: false,
            valid: true,
            // 本文
            template: '',
            // タブで選択されている配信種別
            deliveryType: '',
            rules: {
                checkEmpty: value => validater.checkEmptyString(value) || this.$t('error.validation.required.any')
            },
            fromSetData: {
                delivery_id: '',
                delivery_date: '',
                delivery_name: '',
                golf_name: ''
            },
            process: {
                result: '',
                resultText: '',
                btnDisabled: 0
            },
            // データテーブルに渡す値
            desserts: [],
            // データテーブルの見出し要素
            headers: [
                { text: '配信方法', sortable: false, value: 'code_name' },
                { text: '送信対象', align: 'right', sortable: false, value: 'executed_number_char' },
                { text: '送信実行', align: 'right', sortable: false, value: 'delivery_result_ok_char' }
            ]
        };
    },
    methods: {
    /** ----------------------------------------------
     * 初期表示時処理
     * ---------------------------------------------- */
        Initialize () {
            this.fromSetData = {
                delivery_id: '',
                delivery_date: '',
                delivery_name: ''
            };
        },
        /** ----------------------------------------------
         * 詳細取得
         * ---------------------------------------------- */
        GetDeliveryActualsDetails: async function (item) {
            try {
                let res = await this.$apollo
                    .mutate({
                        fetchPolicy: 'no-cache',
                        mutation: GET_DELIVERY_ACTUALS_DETAILS,
                        variables: {
                            delivery_id: item.delivery_id,
                            delivery_date: item.delivery_date
                        }
                    });
                this.desserts = res.data.getDeliveryActualsDetails.DeliveryActualsDetailsList;
            } catch (error) {
                this.error = error;
            }
        },
        /** --------------------------------------------
        * モーダル画面を表示
        * -------------------------------------------- */
        OpenModal: async function (item, golfCourse) {
            this.Initialize();
            this.fromSetData.delivery_id = item.delivery_id;
            this.fromSetData.delivery_date = item.delivery_date;
            this.fromSetData.delivery_name = item.delivery_name;
            this.fromSetData.golf_name = golfCourse.golf_name;
            await this.GetDeliveryActualsDetails(item);
            this.dialog = true;
            this.$nextTick(function () {
                this.$refs.form.resetValidation();
            });
        },
        /** ----------------------------------------------
         * モーダル画面を閉じる際の処理
         * ---------------------------------------------- */
        CloseModal () {
            this.dialog = false;
            this.$emit('from-Dialog');
            this.Initialize();
        },
        /** ----------------------------------------------
         * 確認ダイアログを閉じる
         * ---------------------------------------------- */
        closeAddOverLay () {
            this.$set(this.process, 'result', '');
        }
    }
};
</script>

<style scoped>

.formHeight{
  max-height: 60px;
  max-width: 100%;
}

.v-text-field {
    padding-top: 0px;
    margin-top: 0px;
}
</style>
